<form role="form" [formGroup]="legalForm">

  <div class="row">

    <legend>
      <h3>Registro Persona Jurídica.</h3>
      <h3>Datos Básicos.</h3>
    </legend>

    <div class="alert alert alert-danger" role="alert">
      <b>Importante!</b>
      <p>
        Por favor registre los datos exactamente como aparecen en la Registro de Cámara de Comercio, estos
        datos serán usados para la generación de los Documentos asociados al trámite solicitado y su
        posterior reporte a entidades de vigilancia y control.
      </p>
    </div>

    <div class="col-sm-12 col-md-12">
      <div class="entradas-de-texto-govco">
        <label for="razon-social">Razón Social<span class="required">(*)</span></label>
        <input type="text" id="razon-social" placeholder="Razón Social" formControlName="nombreRazonSocial"
               aria-describedby="Razón Social-note"
               [ngClass]="{'error': isTouchedField(legalForm, 'nombreRazonSocial')}"/>
        <span class="error-texto-govco alert-entradas-de-texto-govco"
              id="razón-Social-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('nombreRazonSocial') }}
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div class="entradas-de-texto-govco">
          <label for="tipoDedentificacion">Tipo de Identificación<span class="required">(*)</span></label>
          <select class="form-select" id="tipoDedentificacion" aria-label="Default select example"
                  formControlName="tipoDocumentoRepresentanteLegal"
                  [ngClass]="{'error': isTouchedField(legalForm, 'tipoDocumentoRepresentanteLegal')}">
            <option value="" selected disabled>Seleccione</option>
            <option [value]="Nit.idTipoIdentificacion">{{Nit.descripcion}}</option>
          </select>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="Tipo de Identificación-note" role="alert"
            aria-live="assertive">
            {{ getErrorMessage('tipoDocumentoRepresentanteLegal') }}
          </span>
        </div>
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="entradas-de-texto-govco">
          <label for="nit">NIT<span class="required">(*)</span></label>
          <input type="text" id="nit" placeholder="NIT" formControlName="numeroDocumentoRepresentanteLegal"
                 [ngClass]="{'error': isTouchedField(legalForm, 'numeroDocumentoRepresentanteLegal')}"/>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="NIT-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('numeroDocumentoRepresentanteLegal') }}
          </span>
        </div>
      </div>
    </div>

    <legend>
      <h3>Representante Legal.</h3>
    </legend>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="primer-nombre">Primer Nombre<span class="required">(*)</span></label>
        <input type="text" id="primer-nombre" placeholder="Primer Nombre" formControlName="primerNombre"
               [ngClass]="{'error': isTouchedField(legalForm, 'primerNombre')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="primer-nombre-note" role="alert"
          aria-live="assertive">
            {{ getErrorMessage('primerNombre') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="segundo-nombre">Segundo Nombre</label>
        <input type="text" id="segundo-nombre" placeholder="Segundo Nombre" formControlName="segundoNombre"/>
      </div>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="primer-apellido">Primer Apellido<span class="required">(*)</span></label>
        <input type="text" id="primer-apellido" placeholder="Primer Apellido" formControlName="primerApellido"
               [ngClass]="{'error': isTouchedField(legalForm, 'primerApellido')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="primer-apellido-note" role="alert"
          aria-live="assertive">
            {{ getErrorMessage('primerApellido') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="segundo-apellido">Segundo Apellido</label>
        <input type="text" id="segundo-apellido" placeholder="Segundo Apellido" formControlName="segundoApellido"/>
      </div>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="tipoIdendificacionId">Tipo identificación<span class="required">(*)</span></label>
        <select class="form-select" id="tipoIdendificacionId" aria-label="Default select example"
                formControlName="tipoDocumento" [ngClass]="{'error': isTouchedField(legalForm, 'tipoDocumento')}">
          <option value="" selected disabled>Seleccione</option>
          <option *ngFor="let tipoiden of tipoIdentificacionn"
                  [value]="tipoiden.idTipoIdentificacion">{{tipoiden.descripcion}}</option>
          <span
            class="error-texto-govco alert-entradas-de-texto-govco" id="tipoIdendificacionId-note" role="alert"
            aria-live="assertive">
            {{ getErrorMessage('tipoDocumento') }}
          </span>
        </select>
      </div>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="nDocumentoIdentidad">N. Documento Identidad<span class="required">(*)</span></label>
        <input type="text" id="nDocumentoIdentidad" placeholder="Número Documento Identidad"
               formControlName="numeroIdentificacion"
               [ngClass]="{'error': isTouchedField(legalForm, 'numeroIdentificacion')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="N. Documento Identidad-note" role="alert"
          aria-live="assertive">
            {{ getErrorMessage('numeroIdentificacion') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="telefonoFijo">Teléfono fijo</label>
        <input type="text" id="telefonoFijo" placeholder="Teléfono fijo" formControlName="telefonoFijo"
               [ngClass]="{'error': isTouchedField(legalForm, 'telefonoFijo')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="Teléfono fijo-note" role="alert"
          aria-live="assertive">
            {{ getErrorMessage('telefonoFijo') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-3">
      <div class="entradas-de-texto-govco">
        <label for="telefonoCelular">Teléfono celular<span class="required">(*)</span></label>
        <input type="text" id="telefonoCelular" placeholder="Teléfono celular" formControlName="telefonoCelular"
               [ngClass]="{'error': isTouchedField(legalForm, 'telefonoCelular')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="Teléfono celular-note" role="alert"
          aria-live="assertive">
            {{ getErrorMessage('telefonoCelular') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="correoElectronico">Correo electrónico<span class="required">(*)</span></label>
        <input type="text" id="correoElectronico" placeholder="Correo electrónico" formControlName="email"
               [ngClass]="{'error': isTouchedField(legalForm, 'email')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="email-note" role="alert" aria-live="assertive">
            {{ getErrorMessage('email') }}
        </span>
      </div>
    </div>

    <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
        <label for="confirmarCorreoElectrónico">Confirmar Correo electrónico<span class="required">(*)</span></label>
        <input type="text" id="confirmarCorreoElectrónico" placeholder="Confirmar Correo electrónico"
               formControlName="confirmarEmail" [ngClass]="{'error': isTouchedField(legalForm, 'confirmarEmail')}"/>
        <span
          class="error-texto-govco alert-entradas-de-texto-govco" id="Confirmar Correo electrónico-note" role="alert"
          aria-live="assertive">
            {{ getErrorMessage('confirmarEmail') }}
        </span>
      </div>
    </div>

    <div id="div_enviar" class="col-12 col-md-12 pl-4 mt-4">
      <div class="col-sm-12">
        <input type="checkbox" name="acepta_terminos" id="acepta_terminos" formControlName="checkBoxDatosPersonales"
               [ngClass]="{'error': isTouchedField(legalForm, 'checkBoxDatosPersonales')}">
        He leído y acepto la
        <a href="https://tramitesenlinea.saludcapital.gov.co/registro/tratamiento_datos" target="_blank">
          política de protección y tratamiento de datos personales.
        </a>
      </div>
      <span
        class="error-texto-govco alert-entradas-de-texto-govco" id="checkBoxDatosPersonales-note" role="alert"
        aria-live="assertive">
            {{ getErrorMessage('checkBoxDatosPersonales') }}
        </span>
    </div>

    <div class="col-12 col-md-12 pl-4 text-center">
      <div class="col-12">
        <br><br>
        <button (click)="SaveLegalPerson()" [disabled]="sending" type="button" class="btn-govco fill-btn-govco">
          Guardar y Terminar
        </button>
        <br><br>
        <button (click)="regresar()" [disabled]="sending" type="button" class="btn-govco fill-btn-govco">
          Regresar
        </button>
      </div>
    </div>

  </div>
</form>

